
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/match-centre",
      function () {
        return require("private-next-pages/team/match-centre.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/match-centre"])
      });
    }
  